// UI hidden per user request — background refresh still runs via useVehicles hook
function VehicleDataStatus() {
  return null;
}

export default VehicleDataStatus;